module.exports = __webpack_public_path__ + "img/honor_7.677ade67.png";